import React,{useEffect} from 'react';
import {connect} from "react-redux";
import {
    runAllListUpdates, runAllUserUpdates
} from 'src/containers/gameTime/common/gameTimeFunctions';
import store from 'src/store';


const TDPDataManager  = (props) => {
    let stateData = store.getState();
    let runuser=props.runuser ? props.runuser : ()=>runAllUserUpdates();
    let runlist=props.runlist ? props.runlist : (list)=>runAllListUpdates(list);
    //let estRoom=props.estRoom ? props.defaultRoom : ()=>establishDefaultRoom();
    useEffect(()=>{
        if (stateData.user.token && typeof stateData.user.token ==="string" && stateData.user.token!=="") {
            runuser()
        }
        //eslint-disable-next-line
    },[stateData.user.token]);


    useEffect(()=>{
        if(stateData.gameTime.chosenList && typeof stateData.gameTime.chosenList==="string" && stateData.gameTime.chosenList!=="") {
            runlist(stateData.gameTime.chosenList);
        }
        //eslint-disable-next-line
    },[stateData.gameTime?.chosenList]);

    //if(stateData.gameTime && stateData.gameTime.myRoomDict && !stateData.gameTime.myRoomDict.hasOwnProperty("default") && obtainSettingsValue("defRoom")){
    //    estRoom();
    //}

    return <span id="tdpdatamanagermount" style={{display:"none"}} >DM</span>
};

const mapStateToProps = (state) =>{
    return {
        user:state.user,
        gameTime:state.gameTime
    };
};

export default connect(mapStateToProps,{})(TDPDataManager);
